"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassSerializer = void 0;
const roles_constants_1 = require("../constants/roles.constants");
class ClassSerializer {
    constructor(userSerializer) {
        this.userSerializer = userSerializer;
    }
    serializeOne({ id, name, content, primaryTeacher, teachers, school, totalStudents = 0, grade, district, }) {
        return {
            id,
            name,
            owner: primaryTeacher
                ? this.userSerializer.serializeOne(Object.assign(Object.assign({}, primaryTeacher), { role: roles_constants_1.TEACHER_ROLE }))
                : undefined,
            teachers: (teachers || []).map((teacher) => this.userSerializer.serializeOne(Object.assign(Object.assign({}, teacher), { role: roles_constants_1.TEACHER_ROLE }))),
            content: this.serializeContent(content),
            school: school ? { id: school.id, name: school.name } : undefined,
            totalStudents: +totalStudents,
            primaryTeacher: primaryTeacher
                ? this.userSerializer.serializeOne(Object.assign(Object.assign({}, primaryTeacher), { role: roles_constants_1.TEACHER_ROLE }))
                : undefined,
            grade: grade ? { id: grade.id, name: grade.name } : undefined,
            district: district ? { id: district.id, name: district.name } : undefined,
        };
    }
    serializeOneV3({ id, name, primaryTeacher, school, grade, subject, district, externalContextId, }) {
        return {
            id,
            name,
            owner: primaryTeacher
                ? this.userSerializer.serializeOnePrimaryTeacher(Object.assign(Object.assign({}, primaryTeacher), { role: roles_constants_1.TEACHER_ROLE }))
                : undefined,
            school: school ? { id: school.id, name: school.name } : undefined,
            primaryTeacher: primaryTeacher
                ? this.userSerializer.serializeOnePrimaryTeacher(Object.assign(Object.assign({}, primaryTeacher), { role: roles_constants_1.TEACHER_ROLE }))
                : undefined,
            grade: grade ? { id: grade.id, name: grade.name } : undefined,
            district: district ? { id: district.id, name: district.name } : undefined,
            externalContextId,
            subject,
        };
    }
    serializeContent(content) {
        return (content || []).map(({ product, course }) => ({
            product: {
                id: product.id,
                name: product.name,
            },
            course: {
                id: course.id,
                name: course.name,
                curriculum: {
                    id: course.curriculum.id,
                    name: course.curriculum.name,
                },
            },
        }));
    }
}
exports.ClassSerializer = ClassSerializer;
//# sourceMappingURL=class.serializer.js.map